export default __webpack_public_path__ + "static/media/Fona_de.3edcb504.png";